// reducers.js
import { combineReducers } from "redux";
import { connectRouter, RouterState } from "connected-react-router";
import { FormState, reducer as formReducer } from "redux-form";

import { AuthState } from "./auth/interface";
import auth from "./auth/reducer";

import { UIState } from "./ui/interface";
import ui from "./ui/reducer";

export interface ApplicationState {
	router: RouterState;
	form: FormState | any;
	auth: AuthState | any;
	ui: UIState;
}

const appReducers = (history: any) =>
	combineReducers<ApplicationState>({
		router: connectRouter(history),
		form: formReducer,
		auth: auth,
		ui: ui,
	});

export default appReducers;
